import {Text} from 'react-native';
import React from 'react';
import {withDatabase} from '@nozbe/watermelondb/react';
import {withObservables} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {compose} from 'recompose';
import {Target} from 'src/models';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';

const TargetName = ({target, textStyle}: any) => {
  return <Text style={[...(textStyle || [])]}>{target?.name}</Text>;
};

export default compose(
  withDatabase,
  withState,
  withObservables(['targetId'], ({targetId, database}: any) => ({
    target: database
      .get(Target.table)
      .findAndObserve(targetId)
      .pipe(catchError(() => of({}))),
  })),
)(TargetName);
